module.exports = __webpack_public_path__ + "static/media/caregility_logo_large.e706d6b1.png";